import {HttpClient} from '@angular/common/http';
import {
	TRANSLOCO_LOADER,
	Translation,
	TranslocoLoader,
	TRANSLOCO_CONFIG,
	translocoConfig,
	TranslocoModule
} from '@ngneat/transloco';
import {Injectable, NgModule} from '@angular/core';
import {environment} from '../environments/environment';
import {AvailableLangs} from '../environments/environment.interface';

@Injectable({providedIn: 'root'})
export class TranslocoHttpLoader implements TranslocoLoader {
	constructor(private http: HttpClient) {}

	getTranslation(lang: string) {
		return this.http.get<Translation>(`${environment.baseUrl}/assets/i18n/${lang}.json`);
	}
}

@NgModule({
	exports: [TranslocoModule],
	providers: [
		{
			provide: TRANSLOCO_CONFIG,
			useValue: translocoConfig({
				availableLangs: Object.keys(AvailableLangs),
				defaultLang: environment.defaultLang,
				fallbackLang: 'en',
				reRenderOnLangChange: true,
				prodMode: environment.production,
				missingHandler: {
					useFallbackTranslation: true
				}
			})
		},
		{provide: TRANSLOCO_LOADER, useClass: TranslocoHttpLoader}
	]
})
export class TranslocoRootModule {
}
